import { render } from "./dataInvoicePersonEn.vue?vue&type=template&id=0f2f2826&scoped=true"
import script from "./dataInvoicePersonEn.vue?vue&type=script&lang=js"
export * from "./dataInvoicePersonEn.vue?vue&type=script&lang=js"

import "./dataInvoicePersonEn.vue?vue&type=style&index=0&id=0f2f2826&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2f2826"]])

export default __exports__